import React from 'react'
import Input from './VolumeStyled'
import { Label } from '../toggleSwitch/ToggleSwitchStyled'

interface VolumeProps {
  saveUserSetting: (args0: number) => void
  value?: string
}
export const Volume = ({ saveUserSetting, value }: VolumeProps) => {
  return (
    <Label>
      <h3>Volume</h3>
      <Input
        defaultValue={value}
        onMouseUp={(e: any) => saveUserSetting(+e.target.value)}
        onTouchEnd={(e: any) => saveUserSetting(+e.target.value)}
        type='range'
        max='1'
        min='0'
        step='0.1'
      />
    </Label>
  )
}
